<template>
  <div class="big-text">
    <h2
      class="big-text__title"
      :style="{ color: textColor }"
      v-html="text">
    </h2>
  </div>
</template>

<script setup>
  // Props
  defineProps({
    text: {
      type: String,
      required: true,
      validator: value => typeof value === 'string' && value.trim().length > 0
    },
    textColor: {
      type: String,
      default: 'var(--color-red)'
    }
  })
</script>

<style lang="scss" scoped>
.big-text {
  &__title {
    font-family: var(--font-family-poppins);
    font-size: 60px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    margin: 0;
    overflow-wrap: break-word;

    :deep(strong) {
      font-weight: 700;
    }

    :deep(em) {
      font-style: italic;
    }

    :deep(span) {
      color: inherit;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
      text-transform: inherit;
    }

    @include mq($until: tablet) {
      font-size: 40px;
      line-height: 120%;
    }

    @include mq($until: mobile) {
      font-size: 32px;
      line-height: 115%;
    }
  }
}
</style>
